<script setup lang="ts">
// markstream custom component for a Slack `<#C…>` channel reference,
// emitted by slackMarkdown.ts as `<channel id="C12" name="sales">`.
// Renders an inline `#name` pill. We don't resolve channel ids to a
// directory yet, so the name comes from the inline attr (Slack always
// includes it for channels the workspace can see) or falls back to
// 'channel'. The `#` text is the marker - no glyph icon.
import { computed } from 'vue';
import { attr } from './nodeAttrs';

const props = defineProps<{ node: any }>();

const name = computed(() => attr(props.node, 'name') || 'channel');
</script>

<template>
  <span class="channel-chip" :title="`#${name}`">#{{ name }}</span>
</template>

<style scoped>
.channel-chip {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: var(--radius-pill);
  background: var(--surface-sunken);
  color: var(--ink-primary);
  font-size: 0.9em;
  font-weight: 600;
  line-height: 1.4;
  vertical-align: baseline;
  white-space: nowrap;
}
</style>
